<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16Jpo71/image/cover.jpg?1731429793740" alt="This image is the cover for the book Hearth Witch's Kitchen Herbal"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hearth Witch's Kitchen Herbal
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Herbal Wisdom the Hearth Witch Way</b></p><p><i>Includes more than 150 recipes for teas, infusions, tinctures, syrups, baths, salves, balms, compresses, poultices, oils, creams, potions, candles, and much more.</i></p><p><i>The Hearth Witch's Kitchen Herbal</i> is an herbal with a difference—it shows how to use the herbs and spices most of us already have in our kitchens for home remedies, personal care, spiritual practice, spells, and rituals. The follow-up to the bestselling <i>Hearth Witch's Compendium</i>, this practical guide includes more than 150 recipes and focuses on twenty-three common culinary herbs and spices. For each plant, you will discover magical correspondences, culinary uses, cosmetic uses, medicinal uses, notes of caution, recipes, and lore. Also discover how to combine herbs with astrology, colors, and elemental energies for powerful magical workings. From basil to turmeric and incenses to syrups, this useful kitchen herbal is designed to help you expand your Hearth Witch skills for a more natural and magical life.</p>BasilBlack PepperCarawayCardamomCayenneCinnamonCloveCorianderCuminDillFennelFenugreekGarlicGingerLemonMintsOatsOreganoParsleyRosemarySageThymeTurmeric
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anna Franklin
      </h2>
      
      <p class="authorDescription body article"><P><B>Anna Franklin</B> is a third-degree witch and high priestess of the Hearth of Arianrhod who has been a practicing Pagan for more than forty years. She is the author of nearly thirty books, including the Hearth Witch series, and the creator of the <I>Sacred Circle Tarot</I>, <I>Fairy Ring Oracle</I>, and the <I>Pagan Ways Tarot</I>. Her books have been translated into nine languages. Anna has contributed hundreds of articles to Pagan magazines and has appeared on radio and TV. She lives and works in a village in the English Midlands where she grows her own herbs, fruit, and vegetables, and generally lives the Pagan life. Visit her at AnnaFranklin.co.uk.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Llewellyn is a registered trademark of Llewellyn Worldwide Ltd. 
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9a4892f4